// src/config.js
export const FORM_PERIOD = {
    start: "2025/05/01 00:00:00",
    end: "2025/06/31 23:59:59"
  };

  export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
